import { IStation, ILocation } from '../api/station/types';
import { unavailableStationAndConnectorStatuses } from '../constants';

export const buildSetupPath = (
    locationId: string,
    stationId: string,
    connectorId: string,
    step: 'setup-connector' | 'confirm-details' | `pay/${string}`
) => `/locations/${locationId}/${stationId}/${connectorId}/${step}`;

export const getStationCurrency = (station?: IStation) => {
    return station?.user?.country?.currency || station?.currency || 'CAD';
};

export const isStationUnavailable = (station?: IStation): boolean => {
    if (!station) return false;
    return (
        station.mode === 'Inactive' ||
        !station.online ||
        unavailableStationAndConnectorStatuses.includes(station.status)
    );
};

export const getStationConnectorId = (station?: IStation, _id?: string) => {
    if (!station || !_id) return undefined;
    const i = station?.connectors.findIndex(connector => connector._id === _id);
    if (i === -1) return undefined;
    return i + 1;
};

export const getStationLocationId = (station?: IStation): string | undefined => {
    const location = station?.stationLocation;
    if (!location) return undefined;
    return typeof location === 'string' ? location : location._id;
};

export const formatStationLocationAddress = (location?: ILocation): string | undefined => {
    if (!location?.address) return undefined;

    const { street_1, street_2, province, country, zip } = location.address;

    return `${street_1}${street_2 ? `, ${street_2}` : ''}${province ? `, ${province} ` : ''}${country ? `, ${country} ` : ''}${zip}`;
};

export const getStationLocationName = (station?: IStation): string | undefined => {
    return station?.stationLocation?.name;
};

export const buildPayPath = (guestId: string): string => `/pay/${guestId}`;

export const buildStationConnectorPath = (
    stationId: string,
    connectorId: string,
    step?: 'confirm-details'
): string => {
    const base = `/stations/${stationId}/${connectorId}`;

    if (step === 'confirm-details') {
        return `${base}/confirm-details`;
    }

    return base;
};
